import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { useAlert } from "../../../context/AlertContext";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  Container,
  Tab,
  Tabs,
  Card,
  Button,
  Form,
} from "react-bootstrap";
import SearchFilter from "../../../components/SearchFilter";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import InputSearch from "../../../components/InputSearhComponent";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import { toFormatISO } from "../../../utils/Time";
import { getQueryString } from "../../../utils/Query";
import TableForm2s from "../../../components/TableFormScrb";
import TechDeliverDocService from "../../../services/techdeliverydoc";
import { formatDate } from "../../../commons/FormatValue";
import DepartJobsService from "../../../services/departjob.service";
import TechniciansService from "../../../services/technician.service";
import EmployeesService from "../../../services/employee.service";

export default function DeliveryDocuments() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [allCountData, setAllCountData] = useState();
  const [DepartJobs, setDepartJobs] = useState([]);
  const [TechMas, setTechMas] = useState([]);

  const [showModal, setShowModal] = useState({
    deliveryDoc: {},
    TCSCheckDoc: {},
    BSCCheckDoc: {}
  });
  const [searchValue, setSearchValue] = useState({
    deliveryDoc: [],
    TCSCheckDoc: [],
    BSCCheckDoc: []
  });
  const [data, setData] = useState({
    deliveryDoc: [],
    TCSCheckDoc: [],
    BSCCheckDoc: []
  });

  const columns = {
    deliveryDoc: [
      {
        name: "Seq_No",
        label: "เลขที่ใบสั่งงาน",
        readOnly: true
      },
      {
        name: "Ref_Do_No",
        label: "เลขที่ใบเบิก",
        readOnly: true
      },
      {
        name: "Bill_Doc_No",
        label: "เลขที่ใบขอเบิก",
        readOnly: true
      },
      {
        name: "Item_Return_No",
        label: "เลขที่ใบขอคืน",
        readOnly: true
      },
      {
        name: "Service_Rep_No",
        label: "เลขใบงานบริการ",
        readOnly: true
      },
      {
        name: "Seq_St_Id",
        label: "สถานะใบสั่งงาน",
        format: (row) => DepartJobs.find(s => s.Seq_St_Id == row.Seq_St_Id)?.Depart_St_Name,
        readOnly: true
      },
      {
        name: "Tech_Delivery_Date",
        label: "วันที่ช่างนำส่ง",
        readOnly: true
      },
      {
        name: "Delivery_Id",
        label: "ผู้ส่งเอกสาร",
        readOnly: true,
        format: (row) => TechMas.find(s => s.Id == row.Delivery_Id)?.Tech_Mas_Name,
      },
      {
        name: "Depart_St_Name",
        label: "สถานะ",
        readOnly: true
      },
    ],
    TCSCheckDoc: [
      {
        name: "Seq_No",
        label: "เลขที่ใบสั่งงาน",
        readOnly: true
      },
      {
        name: "Ref_Do_No",
        label: "เลขที่ใบเบิก",
        readOnly: true
      },
      {
        name: "Bill_Doc_No",
        label: "เลขที่ใบขอเบิก",
        readOnly: true
      },
      {
        name: "Item_Return_No",
        label: "เลขที่ใบขอคืน",
        readOnly: true
      },
      {
        name: "Service_Rep_No",
        label: "เลขใบงานบริการ",
        readOnly: true
      },
      {
        name: "Seq_St_Id",
        label: "สถานะใบสั่งงาน",
        format: (row) => DepartJobs.find(s => s.Seq_St_Id == row.Seq_St_Id)?.Depart_St_Name,
        readOnly: true
      },
      {
        name: "Tech_Delivery_Date",
        label: "วันที่ช่างนำส่ง",
        readOnly: true
      },
      {
        name: "Accept_Date",
        label: "วันที่ตรวจรับ",
        readOnly: true,
      },
      {
        name: "Employee_Tcs",
        label: "ผู้ตรวจรับ",
        readOnly: true,
        // format: (row) => TechMas.find(s => s.Id == row.Employee_Tcs)?.Tech_Mas_Name || null
      },
      {
        name: "Depart_St_Name",
        label: "สถานะ",
        readOnly: true
      },
    ],
    BSCCheckDoc: [
      {
        name: "Seq_No",
        label: "เลขที่ใบสั่งงาน",
        readOnly: true
      },
      {
        name: "Ref_Do_No",
        label: "เลขที่ใบเบิก",
        readOnly: true
      },
      {
        name: "Bill_Doc_No",
        label: "เลขที่ใบขอเบิก",
        readOnly: true
      },
      {
        name: "Item_Return_No",
        label: "เลขที่ใบขอคืน",
        readOnly: true
      },
      {
        name: "Service_Rep_No",
        label: "เลขใบงานบริการ",
        readOnly: true
      },
      {
        name: "Seq_St_Id",
        label: "สถานะใบสั่งงาน",
        format: (row) => DepartJobs.find(s => s.Seq_St_Id == row.Seq_St_Id)?.Depart_St_Name,
        readOnly: true
      },
      {
        name: "TCS_Date",
        label: "วันที่TCSนำส่ง",
        readOnly: true
      },
      {
        name: "Accept_Date",
        label: "วันที่ตรวจรับ",
        readOnly: true,
      },
      {
        name: "Employee_Bsc",
        label: "ผู้ตรวจรับ",
        readOnly: true,
      },
      {
        name: "Depart_St_Name",
        label: "สถานะ",
        readOnly: true
      },
    ]
  };

  const searchField = {
    deliveryDoc: [
      {
        name: "start",
        label: "วันที่เข้างานระหว่าง",
        classNames: "mb-3",
        size: 3,
        value: "",
        type: "date"
      },
      {
        name: "end",
        label: "ถึงวันที่",
        classNames: "mb-3",
        size: 3,
        value: "",
        type: "date"
      },
      {
        name: "Sup_team",
        label: "ชื่อทีม/หัวหน้าช่าง",
        classNames: "mb-3",
        size: 3,
        disabled: true,
        // value: null,
        type: "text"
      },
      {
        name: "Technician_name ",
        label: "ช่างผู้ปฏิบัติงาน",
        classNames: "mb-3",
        size: 3,
        disabled: true,
        // value: null,
        type: "text"
      },
    ],
    TCSCheckDoc: [
      {
        name: "date_entered_since",
        label: "วันที่ช่างนำส่ง",
        classNames: "mb-3",
        size: 3,
        value: "",
        type: "date"
      },
      {
        name: "up_to_date",
        label: "ถึงวันที่",
        classNames: "mb-3",
        size: 3,
        value: "",
        type: "date"
      },
      {
        name: "Sup_team",
        label: "ชื่อทีม/หัวหน้าช่าง",
        classNames: "mb-3",
        size: 3,
        disabled: true,
        value: null,
        type: "text"
      },
      {
        name: "technician_practitioner",
        label: "ช่างผู้ปฏิบัติงาน",
        classNames: "mb-3",
        size: 3,
        value: null,
        type: "text"
      },
    ],
    BSCCheckDoc: [
      {
        name: "start",
        label: "วันที่TCSนำส่ง",
        classNames: "mb-3",
        size: 3,
        value: "",
        type: "date"
      },
      {
        name: "end",
        label: "ถึงวันที่",
        classNames: "mb-3",
        size: 3,
        value: "",
        type: "date"
      },
      {
        name: "Sup_team",
        label: "ชื่อทีม/หัวหน้าช่าง",
        classNames: "mb-3",
        size: 3,
        disabled: true,
        value: null,
        type: "text"
      },
      {
        name: "technician_practitioner",
        label: "ช่างผู้ปฏิบัติงาน",
        classNames: "mb-3",
        size: 3,
        disabled: true,
        type: "text"
      },
    ]
  };

  useEffect(() => {
    handleChangeTab("deliveryDoc")
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechniciansService.getAllTechnicians(),
      callback: (res) => setTechMas(res)
    })
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: DepartJobsService.getAllDepartJobs(),
      callback: (res) => {
        setDepartJobs(res)
      }
    })
  }, []);

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        deliveryDoc: "ช่างนำส่งเอกสาร",
        TCSCheckDoc: "TCS - ตรวจสอบเอกสาร",
        BSCCheckDoc: "BSC - ตรวจรับเอกสาร",
      }
    });
  };

  function getDataDeliveryDoc(search) {
    const q = {
      page: search?.page || 1, limit: search?.limit || 10,
      start: toFormatISO(search.start),
      end: toFormatISO(search.end)
    }
    setCurrentPage(q?.page)
    setRowsPerPage(q?.limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechDeliverDocService.getDocDeliverInform(getQueryString(q)),
      callback: (res) => {
        setData({
          deliveryDoc: res.data.map(el => ({
            Seq_No: el.seq_no,
            Bill_Doc_No: el.BillOfReqHd.Bill_Doc_No,
            Ref_Do_No: el.BillOfReqHd.Ref_Do_No,
            Item_Return_No: el.TechWorkClosed.TechItemReturnBill?.item_return_no,
            Service_Rep_No: el.TechWorkClosed.service_rep_no,
            Seq_St_Id: el.DepartJob?.Seq_St_Id,
            Tech_Delivery_Date: formatDate(el.TechDeliverDoc?.tech_deliver_date),
            Delivery_Id: el.TechDeliverDoc?.tech_mas_id,
            Depart_St_Name: el.DepartJob?.Depart_St_Name,
          }))
        })
        setAllCountData(res.allCount)
      }
    });
  }

  function getDataTCS(search) {
    const q = {
      page: search?.page || 1, limit: search?.limit || 10,
      start: toFormatISO(search.start),
      end: toFormatISO(search.end)
    }
    setCurrentPage(q?.page)
    setRowsPerPage(q?.limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechDeliverDocService.getDocDeliverInform(getQueryString(q)),
      callback: (res) => {

        setData({
          TCSCheckDoc: res.data.map(el => ({
            Seq_No: el.seq_no,
            Bill_Doc_No: el.BillOfReqHd.Bill_Doc_No,
            Ref_Do_No: el.BillOfReqHd.Ref_Do_No,
            Item_Return_No: el.TechWorkClosed.TechItemReturnBill?.item_return_no,
            Service_Rep_No: el.TechWorkClosed.service_rep_no,
            Seq_St_Id: el.DepartJob?.Seq_St_Id,
            Tech_Delivery_Date: formatDate(el.TechDeliverDoc?.tech_deliver_date),
            Accept_Date: formatDate(el.TechDeliverDoc?.tcs_accept_date),
            Employee_Tcs: el.TechDeliverDoc?.EmployeeTcs?.Employee_Name,
            Depart_St_Name: el.DepartJob?.Depart_St_Name,
          }))
        })
        setAllCountData(res.allCount)
      }
    });
  }
  function getDataBSC(search) {
    const q = {
      page: search?.page || 1, limit: search?.limit || 10,
      start: toFormatISO(search.start),
      end: toFormatISO(search.end)
    }
    setCurrentPage(q?.page)
    setRowsPerPage(q?.limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechDeliverDocService.getDocDeliverInform(getQueryString(q)),
      callback: (res) => {

        setData({
          BSCCheckDoc: res.data.map(el => {

            return {
              Seq_No: el.seq_no,
              Bill_Doc_No: el.BillOfReqHd.Bill_Doc_No,
              Ref_Do_No: el.BillOfReqHd.Ref_Do_No,
              Item_Return_No: el.TechWorkClosed.TechItemReturnBill?.item_return_no,
              Service_Rep_No: el.TechWorkClosed.service_rep_no,
              Seq_St_Id: el.DepartJob?.Seq_St_Id,
              TCS_Date: formatDate(el.TechDeliverDoc?.tcs_accept_date),
              Accept_Date: formatDate(el.TechDeliverDoc?.bsc_accept_date),
              Employee_Bsc: el.TechDeliverDoc?.EmployeeBsc?.Employee_Name,
              Depart_St_Name: el.DepartJob?.Depart_St_Name,
            }
          })
        })
        setAllCountData(res.allCount)
      }
    });
  }

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Delivery Of Documents" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          defaultActiveKey={state?.tab || "deliveryDoc"}
          justify
          className="mb-3"
          onSelect={handleChangeTab}
        >
          <Tab eventKey="deliveryDoc" title="ช่างนำส่งเอกสาร">
            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Title className="mb-4 mt-2 fs-2 text-center">
                ข้อมูลการนำส่งเอกสาร
              </Card.Title>
              <Card.Body>
                <InputSearch
                  field={searchField.deliveryDoc}
                  inputField={searchField.deliveryDoc}
                  fieldClassName={{
                    inputRow: "justify-content-center align-items-center",
                    actionButton: "w-auto py-2"
                  }}
                  searchCallback={(search) =>
                    search ? getDataDeliveryDoc(search) : setData({ deliveryDoc: [] })
                  }
                />
              </Card.Body>
            </Card>

            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Header className="p-3 pb-1 fs-2 text-dark d-flex justify-content-between bg-transparent border-bottom-0">
                รายละเอียดข้อมูลการนำส่งเอกสาร

                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 rounded-pill"
                  onClick={() => navigate("add", { state: { DepartJobs: DepartJobs, TechMas: TechMas } })}
                >
                  เพิ่มข้อมูลนำส่งเอกสาร
                </Button>
              </Card.Header>
              <Card.Body>
                <Form noValidate className="pb-4" >
                  <TableForm2s
                    data={data?.deliveryDoc || []}
                    columns={columns.deliveryDoc}
                    pending={loading}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    rowCount={allCountData}
                    fetchData={getDataDeliveryDoc}
                  />
                </Form>
              </Card.Body>
            </Card>

          </Tab>

          <Tab eventKey="TCSCheckDoc" title="TCS - ตรวจสอบเอกสาร">
            <Card className="m-1 mb-4 p-4 border-0 ">
              <Card.Title className="mb-4 mt-2 fs-2 text-center">
                ข้อมูลการนำส่งเอกสาร
              </Card.Title>

              <Card.Body>
                <InputSearch
                  field={searchField.TCSCheckDoc}
                  inputField={searchField.TCSCheckDoc}
                  fieldClassName={{
                    inputRow: "justify-content-center align-items-center",
                    actionButton: "w-auto py-2"
                  }}
                  searchCallback={(search) =>
                    search ? getDataTCS(search) : setData({ TCSCheckDoc: [] })
                  }
                />
              </Card.Body>
            </Card>

            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Header className="p-3 pb-1 fs-2 text-dark d-flex justify-content-between bg-transparent border-bottom-0">
                รายละเอียดข้อมูลการนำส่งเอกสาร

                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 rounded-pill"
                  onClick={() => navigate("edit", {
                    state: {
                      type: "TCSCheckDoc",
                      DepartJobs: DepartJobs
                    }
                  })}
                >
                  ตรวจรับเอกสาร
                </Button>
              </Card.Header>
              {/* <Table
                data={data.TCSCheckDoc}
                column={columns.TCSCheckDoc}
                searchFilter={searchValue.TCSCheckDoc}
              /> */}
              <Form noValidate className="pb-4" >
                <TableForm2s
                  data={data?.TCSCheckDoc || []}
                  columns={columns.TCSCheckDoc}
                  pending={loading}
                  rowsPerPage={rowsPerPage}
                  currentPage={currentPage}
                  rowCount={allCountData}
                  fetchData={getDataTCS}
                />
              </Form>
            </Card>

          </Tab>

          <Tab eventKey="BSCCheckDoc" title="BSC - ตรวจรับเอกสาร">
            <Card className="m-1 mb-4 p-4 border-0 ">
              <Card.Title className="mb-4 mt-2 fs-2 text-center">
                ข้อมูลการนำส่งเอกสาร
              </Card.Title>
              <Card.Body>
                <InputSearch
                  field={searchField.BSCCheckDoc}
                  inputField={searchField.BSCCheckDoc}
                  fieldClassName={{
                    inputRow: "justify-content-center align-items-center",
                    actionButton: "w-auto py-2"
                  }}
                  searchCallback={(search) =>
                    search ? getDataBSC(search) : setData({ BSCCheckDoc: [] })
                  }
                />
              </Card.Body>
            </Card>

            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Header className="p-3 pb-1 fs-2 text-dark d-flex justify-content-between bg-transparent border-bottom-0">
                รายละเอียดข้อมูลการนำส่งเอกสาร

                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 rounded-pill"
                  onClick={() => navigate("edit", {
                    state: {
                      type: "BSCCheckDoc",
                      DepartJobs: DepartJobs
                    }
                  })}
                >
                  ตรวจรับเอกสาร
                </Button>
              </Card.Header>
              <Form noValidate className="pb-4" >
                <TableForm2s
                  data={data?.BSCCheckDoc || []}
                  columns={columns.BSCCheckDoc}
                  pending={loading}
                  rowsPerPage={rowsPerPage}
                  currentPage={currentPage}
                  rowCount={allCountData}
                  fetchData={getDataBSC}
                />
              </Form>
            </Card>

          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
